export const searchCenterLocation = {
  selectedMatches: 'selectedMatches',
  allMatches: 'allMatches',
  summary: 'summary',
};
